<template>
  <div class="crudblock">
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      :search.sync="form"
      @search-reset="searchReset"
      @on-load="onLoad"
      @search-change="searchChange"
    >
      <template slot="searchMenu" slot-scope="{ row, size }">
        <el-button type="primary" @click="save(row)">保存</el-button>
        <el-button  type="primary"  @click="screen"
          ><a-icon type="filter" /> 高级筛选</el-button
        >
      </template>
      <template slot="search" slot-scope="{ row, size }">
        <div class="block" style="margin-left: 15px">
          <el-form-item label="模糊搜索">
            <el-input
              v-model="form.search"
              width="150px"
              placeholder="投放名称/收款方/合同名称"
            ></el-input>
          </el-form-item>
        </div>
      </template>
      <template slot="name" slot-scope="{ row }">
        <div class="project-name" @click="handleDetails(row.id)">
          {{ row.name }}
        </div>
      </template>  
      <!-- <template slot-scope="scope" slot="menu">
        <el-button
          type="success"
          plain
          size="small"
          icon="el-icon-arrow-right"
          @click.stop="handleDetails(scope.row.id)"
          >详情
        </el-button>
      </template> -->
    </avue-crud>
    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="option"
              ref="formScreen"
              v-model="form"
              @submit="handleSearch"
              @reset-change="searchResetScreen"
            >
              <template slot-scope="scope" slot="quota">
                <div class="form_slot">
                  <el-input-number
                    :controls="false"
                    v-model="form.quotaMin"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.quotaMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="false"
      :clear="false"
      @setPeople="setPeople"
    />
  </div>
</template>

<script>
import * as api from "@/api/zd/projectconclusion";
import SelectPerson from "@/components/SelectPersonnel/person";

export default {
  data() {
    return {
      form: {},
      drawer: false,
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      data: [],
      timepic: [],
      option: {
        menuType: "button",
        addBtn: false,
        menuWidth: 120,
        menuAlign: "center",
        card: true,
        delBtn: false,
        editBtn: false,
        align: "center",
        searchMenuSpan: 8,
        columnBtn: false,
        searchBtn: true,
        // menuWidth: 300,
        labelWidth: 100,
        column: [
          {
            label: "搜索查询",
            searchPlaceholder: "项目编号/项目名称/客户名称",
            placeholder: "项目编号/项目名称/客户名称",
            prop: "search",
            hide: true,
            display: true,
            search: true,
            hideshow: true,
          },
          {
            sortable: "custom",
            label: "项目编号",
            prop: "number",
            width: "120",
            fixed: true,
            display: false,
          },
          {
            label: "项目名称",
            prop: "name",
            slot:true,
            width: "180",
            fixed: true,
            display: false,
          },
          {
            label: "收尾状态",
            prop: "closeState",
            type: "select",
            search: true,
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=close_state",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dataType: "number",
          },
          {
            label: "客户名称",
            prop: "custName",
            width: "180",
            type: "select",
            filterable:'true' ,
            dicUrl: "/api/blade-/zd/custom/getListDefault",
            dicMethod: "post",
            dicQuery: {},
            props: {
              label: "custName",
              value: "id",
            },
          },
          {
            label: "申请银行",
            prop: "bankName",
            width: 160,
            display: false,
            overHidden: true
          },
          {
            label: "申请银行",
            prop: "bankName",
            hide: true,
            search: true,
            width: "160",
            type: "select",
            filterable:'true' ,
            dicUrl: "/api/blade-/zd/bank/getListDefault",
            dicMethod: "post",
            dicQuery: {},
            props: {
              label: "bankName",
              value: "id",
            },
          },

          {
            label: "申请转贷金额",
            prop: "quota",
            width: "160",
            formslot: true,
            sortable: "custom",
            formatter: (row, value, label, column) => {
              return this.getMoney(value);
            },
          },
          {
            label: "使用费率",
            prop: "loanRate",
            width: "100",
            dataType: "number",
            type: "select",
            dicUrl: "/api/blade-/zd/interestrate/dictionary",
            dicMethod: "get",
            dicQuery: {},
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            display: true,
            formatter: (row, value, label, column) => {
              return value > -1 ? value * 100 + "%": ""
            }
          },

          {
            label: "客户经理",
            prop: "managerName",
            display: false,
          },
          {
            label: "客户经理",
            prop: "managerUserName",
            readonly: true,

            search: true,
            clearable: false,
            display: true,
            hide: true,
            hideshow: true,
            click: () => {
              this.selectPersonClick();
            },
          },
          {
            label: "收尾时间",
            prop: "closeTime",
            width:"100",
            display:false,
            type: "date",
            valueFormat: "yyyy-MM-dd",
            format: "yyyy-MM-dd",
          },

          {
            label: "收尾时间",
            prop: "closeTime1",
            width:"100",
            type: "daterange", 
              format: "yyyy-MM-dd",
              startPlaceholder: '开始',
              endPlaceholder: '结束',
              valueFormat: "yyyy-MM-dd",  
               hide:true,
            display: true,
            hideshow: true
          }
        ],
      },
    };
  },
  watch: {
    files: {
      handler(newName, oldName) {
        
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true,
    },
    timepic: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          (this.form.startDate = this.timepic[0]),
            (this.form.endDate = this.timepic[1]);
        }
      },

      immediate: true,
    },
  },
  props: ["files"],
  components: {
    SelectPerson,
  },
  activated(){
    this.onLoad(this.page)
  },
  methods: {
    //显示高级筛选抽屉
    screen() {
      this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    //高级筛选
    handleSearch(form, done, loading) {
      this.form = { ...this.form, ...form };
      this.drawer = false;
      this.page.currentPage = 1;
      
      this.onLoad(this.page);
      done();
    },

    onLoad(page) {
      let data =JSON.parse(JSON.stringify(this.form))
      if(this.form.closeTime1!=undefined){
      data.closeTimeMin= data.closeTime1[0]
      data.closeTimeMax=data.closeTime1[1]
     }
     delete data["closeTime1"];
     delete data["closeTime"];
      api
        .projectgetCloseList({
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize, 
          ...data,
          closeState: 2,
        })
        .then((res) => {
         
          this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          this.data = res.data.data.list;
        })
        .catch((res) => {
         
        });
    },
    searchChange(params, done) {
      
      // if (this.form.timepic) {
      //   this.form.startDate = this.form.timepic[0];
      //   this.form.endDate = this.form.timepic[1];
      //   delete this.form["timepic"];
      // }

      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.form = {};
      this.timepic = [];
      this.onLoad(this.page);
    },
    //高级筛选清空
    searchResetScreen(){
        this.$refs.crud.searchReset()
    },
    save(row) {
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
      
      this.form = data;

      if (this.form.startDate) {
        this.timepic = [this.form.startDate, this.form.endDate];
      }
      this.searchChange(data);
    },
    handleDetails(id) {
   
      this.$router.push({ path: `/zd/projectconclusion/detail/${id}` });

      // this.$router.push({
      //   path: "/zd/bankmanage/bankmanageDetail/",
      //   query: { id: id }
      // });
    },
    //获取 人员名称
    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        this.form.managerUserName = people.join(",");
        this.form.managerUserIds = ids.join(",");
      });
    },
    // 人员选择插件打开
    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      this.getVisitPeople();
    },
  },
};
</script>

<style lang="scss" scoped>
.crudblock {
  background: #ffff;
  padding: 16px;
  border-radius: 4px;
}
.project-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #409eff;
}
.project-name:hover {
  color: #409eff;
  cursor: pointer;
}
</style>
